import { Country } from '../country';

export interface Threshold {
  freeShipping: number;
  fivePercentOff: number;
  fifteenPercentOff: number;
}

export enum MilestoneKey {
  FreeShipping = 'freeShipping',
  FivePercentOff = 'fivePercentOff',
  FifteenPercentOff = 'fifteenPercentOff',
}

export interface MilestoneMeta {
  key: MilestoneKey;
  title: string;
  anchorPercent: number;
}

export interface CampaignMilestone {
  key: MilestoneKey;
  title: string;
  threshold: number;
  achieved: boolean;
  statusText: string;
  anchorPercent: number;
}

export const thresholdsPerCountry: Record<Country, Threshold> = {
  [Country.UnitedStates]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 85 },
  [Country.Australia]: { freeShipping: 55, fivePercentOff: 90, fifteenPercentOff: 105 },
  [Country.NewZealand]: { freeShipping: 60, fivePercentOff: 100, fifteenPercentOff: 120 },
  [Country.Canada]: { freeShipping: 70, fivePercentOff: 105, fifteenPercentOff: 125 },
  [Country.UnitedKingdom]: { freeShipping: 45, fivePercentOff: 65, fifteenPercentOff: 75 },
  [Country.Singapore]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 90 },
  [Country.Malaysia]: { freeShipping: 170, fivePercentOff: 260, fifteenPercentOff: 310 },
  [Country.UnitedArabEmirates]: { freeShipping: 180, fivePercentOff: 275, fifteenPercentOff: 325 },
  [Country.SaudiArabia]: { freeShipping: 220, fivePercentOff: 320, fifteenPercentOff: 370 },
  [Country.Qatar]: { freeShipping: 215, fivePercentOff: 310, fifteenPercentOff: 360 },
  [Country.Netherlands]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 85 },
  [Country.Belgium]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 85 },
  [Country.Germany]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 85 },
  [Country.France]: { freeShipping: 50, fivePercentOff: 75, fifteenPercentOff: 85 },
  [Country.Poland]: { freeShipping: 230, fivePercentOff: 330, fifteenPercentOff: 380 },
  // [Country.Spain]: { freeShipping: 48, fivePercentOff: 72, fifteenPercentOff: 85 },
  [Country.Turkey]: { freeShipping: 4100, fivePercentOff: 5400, fifteenPercentOff: 6100 },
  [Country.Kazakhstan]: { freeShipping: 46000, fivePercentOff: 63000, fifteenPercentOff: 72000 },
  [Country.Mongolia]: { freeShipping: 220000, fivePercentOff: 310000, fifteenPercentOff: 350000 },
  [Country.Azerbaijan]: { freeShipping: 140, fivePercentOff: 190, fifteenPercentOff: 220 },
  [Country.Switzerland]: { freeShipping: 40, fivePercentOff: 65, fifteenPercentOff: 75 },
  [Country.Denmark]: { freeShipping: 370, fivePercentOff: 560, fifteenPercentOff: 660 },
  [Country.Norway]: { freeShipping: 640, fivePercentOff: 930, fifteenPercentOff: 1080 },
  [Country.Japan]: { freeShipping: 6600, fivePercentOff: 9500, fifteenPercentOff: 11100 },
};

export const BMSM_MILESTONES_META: readonly MilestoneMeta[] = [
  { key: MilestoneKey.FreeShipping, title: 'Free Shipping', anchorPercent: 0.2 },
  { key: MilestoneKey.FivePercentOff, title: '5% OFF', anchorPercent: 0.5 },
  { key: MilestoneKey.FifteenPercentOff, title: '15% OFF', anchorPercent: 0.8 },
] as const;

export const BMSM_PROGRESS_SEGMENTS = {
  firstEndPercent: 20,
  secondEndPercent: 60,
  endPercent: 100,
} as const;

export type BMSMCampaignState =
  | 'Empty cart'
  | 'Less than free shipping'
  | 'Free shipping available'
  | 'Less than 5% OFF'
  | '5% OFF available'
  | 'Less than 15% OFF'
  | '15% OFF available';

export const BMSM_STATE_TO_STEP: Record<BMSMCampaignState, number> = {
  'Empty cart': 0,
  'Less than free shipping': 1,
  'Free shipping available': 2,
  'Less than 5% OFF': 3,
  '5% OFF available': 4,
  'Less than 15% OFF': 5,
  '15% OFF available': 6,
};
